import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import NewsletterForm from "@/components/NewsletterForm";
import ReviewsCarousel from "@/components/ReviewsCarousel";
import { useConsent } from "@/context/ConsentContext";
import logo from "@/assets/logo.png";

export default function Footer() {
  const { openManager } = useConsent();
  return (
    <footer data-testid="site-footer" className="bg-beeswax text-cream/85">
      <ReviewsCarousel />
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Pétales de Miel" data-testid="footer-logo" className="h-11 w-11 object-contain" />
            <span className="font-serif text-xl font-semibold text-cream">Pétales de Miel</span>
          </div>
          <p className="text-sm leading-relaxed text-cream/60">
            Miellerie artisanale en Isère. Des miels de terroir, récoltés à maturité, et le meilleur de la ruche.
          </p>
        </div>

        <div>
          <h4 className="eyebrow mb-4 !text-amber-glow">Explorer</h4>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-link-boutique" to="/boutique" className="transition-colors hover:text-amber-glow">La Boutique</Link></li>
            <li><Link data-testid="footer-link-histoire" to="/histoire" className="transition-colors hover:text-amber-glow">L'Histoire du rucher</Link></li>
            <li><Link data-testid="footer-link-gazette" to="/gazette" className="transition-colors hover:text-amber-glow">La Gazette</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors hover:text-amber-glow">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4 !text-amber-glow">Nous trouver</h4>
          <p className="flex items-start gap-2 text-sm leading-relaxed text-cream/70">
            <MapPin size={16} className="mt-0.5 shrink-0 text-amber-glow" />
            23 Place de Saint-Sauveur, 38220 Notre-Dame-de-Mésage — et le samedi au marché de Vizille.
          </p>
        </div>

        <div>
          <h4 className="eyebrow mb-4 !text-amber-glow">La Gazette Champêtre</h4>
          <p className="mb-3 text-sm text-cream/60">Recettes, nouvelles de la ruche et récoltes en avant-première.</p>
          <NewsletterForm variant="footer" />
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 text-xs text-cream/50 sm:px-8">
          <nav data-testid="footer-legal" className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link data-testid="footer-link-mentions" to="/mentions-legales" className="transition-colors hover:text-amber-glow">Mentions légales</Link>
            <Link data-testid="footer-link-confidentialite" to="/confidentialite" className="transition-colors hover:text-amber-glow">Politique de confidentialité</Link>
            <Link data-testid="footer-link-cookies" to="/cookies" className="transition-colors hover:text-amber-glow">Politique cookies</Link>
            <button data-testid="footer-manage-cookies" onClick={openManager} className="transition-colors hover:text-amber-glow">Gérer mes cookies</button>
          </nav>
          <div className="flex flex-col items-start justify-between gap-3 border-t border-cream/10 pt-4 sm:flex-row sm:items-center">
            <p>© 2026 Pétales de Miel — Tous droits réservés</p>
            <p data-testid="payment-badges">Paiement sécurisé — PayPal · Carte bancaire · Chèque</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
